define("shared/modifiers/autofocus", ["exports", "ember-modifier"], function (_exports, _emberModifier) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.autofocus = autofocus;
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-modifier"eaimeta@70e063a35619d71f
  /**
   * Automatically focuses an element when it is inserted into the DOM.
   *
   * @param element HTMLElement to apply autofocus
   * @param param1 Optional boolean to control whether the element should be focused or not
   */
  function autofocus(element, _ref) {
    let [shouldFocus = true] = _ref;
    // Focus unless explicitly set to false
    if (shouldFocus) {
      element.focus();
    }
  }
  const autofocusModifier = (0, _emberModifier.modifier)(autofocus, {
    eager: false
  });
  var _default = _exports.default = autofocusModifier;
});